import { createContext } from "react";

const ViewportContext = createContext();

export default ViewportContext;